import * as React from "react";
import { SpotlightedStores as SpotlightedStores$1 } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { fromSpotlightedStoresContentToListBlock } from "../../../../hooks/hooks/adapters.js";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { useBloomreachPageRoutes } from "../../../../hooks/hooks/use-bloomreach-page-routes.js";
const CmsSpotlightedStores = ({ content }) => {
  const { routes } = useBloomreachPageRoutes();
  const columns = React.useMemo(() => {
    if (!content) {
      console.warn("no columns defined for CmsSpotlightedStores component");
      return [];
    }
    return [
      fromSpotlightedStoresContentToListBlock("firstListBlock", content?.leftColumn),
      fromSpotlightedStoresContentToListBlock("secondListBlock", content?.middleColumn),
      fromSpotlightedStoresContentToListBlock("thirdListBlock", content?.rightColumn)
    ].filter((column) => column.links.length > 0 || !!column?.title);
  }, [content]);
  if (columns.length === 0) {
    return /* @__PURE__ */ React.createElement("div", { className: "site-container" }, /* @__PURE__ */ React.createElement("h1", null, "No columns defined for CmsSpotlightedStores component"));
  }
  return /* @__PURE__ */ React.createElement(SpotlightedStores$1, { items: columns, storesUrl: routes["store-overview"] });
};
const SpotlightedStores = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent
)(CmsSpotlightedStores);
export {
  CmsSpotlightedStores,
  SpotlightedStores as default
};
//# sourceMappingURL=SpotlightedStores.js.map
